import React from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import reportWebVitals from './reportWebVitals';
import './styles/_styles.scss';
import { Auth0Provider } from '@auth0/auth0-react';
import { getAppConfig } from 'Common/common-ui';
import App from 'src/scripts/App';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

const container = document.querySelector('#root');
const root = createRoot(container);

root.render(
  <Auth0Provider
    domain={getAppConfig().auth0.domain}
    clientId={getAppConfig().auth0.clientId}
    authorizationParams={{
      redirect_uri: window.location.origin,
      scope: 'openid profile offline_access email',
      audience: getAppConfig().auth0.audience,
    }}
    cacheLocation="localstorage"
    useRefreshTokens={true}
  >
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </Auth0Provider>
);

// todo do we need this? what does it do?
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
